// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @ actions
const { validateAndExecute } = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');

const {
    CONFIRM_MODIFY_COMMERCE_AND_ATM_LIMITS_REQUEST,
    CONFIRM_MODIFY_COMMERCE_AND_ATM_LIMITS_SUCCESS,
    CONFIRM_MODIFY_COMMERCE_AND_ATM_LIMITS_FAILURE,

    MODIFY_COMMERCE_AND_ATM_LIMITS_RESET,
    MODIFY_COMMERCE_AND_ATM_LIMITS_SET_VISIBLE_STEP,
    MODIFY_COMMERCE_AND_ATM_LIMITS_VALIDATE,
    MODIFY_COMMERCE_AND_ATM_LIMITS_SHOW_CANCEL_MODAL,
    MODIFY_COMMERCE_AND_ATM_LIMITS_HIDE_WARNING_MODAL,

    LIMITS_DATA_REQUEST,
    LIMITS_DATA_SUCCESS,
    LIMITS_DATA_FAILURE,

    SET_MODIFY_AMOUNT,
    SET_LIMITS_RANGE
} = require('constants/contactCenter/actionTypes');

const {
    FIRST_STEP
} = require('constants/index');

const limitsDataInProgress = () => ({
    type: LIMITS_DATA_REQUEST
});

const limitsDataSuccess = (response, type) => ({
    type: LIMITS_DATA_SUCCESS,
    payload: {
        response,
        type
    }
});

const limitsDataFailure = (error) => ({
    type: LIMITS_DATA_FAILURE,
    payload: {
        error
    }
});

const confirmModifyCommerceAndATMLimitsInProgress = () => ({
    type: CONFIRM_MODIFY_COMMERCE_AND_ATM_LIMITS_REQUEST
});

const confirmModifyCommerceAndATMLimitsSuccess = payload => ({
    type: CONFIRM_MODIFY_COMMERCE_AND_ATM_LIMITS_SUCCESS,
    payload
});

const confirmModifyCommerceAndATMLimitsFailure = error => ({
    type: CONFIRM_MODIFY_COMMERCE_AND_ATM_LIMITS_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: MODIFY_COMMERCE_AND_ATM_LIMITS_RESET
});

const setVisibleStep = step => ({
    type: MODIFY_COMMERCE_AND_ATM_LIMITS_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const showCancelModal = (show) => ({
    type: MODIFY_COMMERCE_AND_ATM_LIMITS_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const hideWarningModal = () => ({
    type: MODIFY_COMMERCE_AND_ATM_LIMITS_HIDE_WARNING_MODAL,
});

const validateStep = step => ({
    type: MODIFY_COMMERCE_AND_ATM_LIMITS_VALIDATE,
    payload: {
        step
    }
});

const setLimitAmount = amount => ({
    type: SET_MODIFY_AMOUNT,
    payload: amount
});

const setLimitRanges = cardType => ({
    type: SET_LIMITS_RANGE,
    payload: cardType
});

const limitsDataRequest = (cardId, type) => (dispatch, getState) => {
    const { cards : immCards } = getState();
    const immCard = immCards.getIn(['byId', cardId]);

    const contractNumber = immCard.getIn(['contract', 'number']);
    const pan = immCard.get('number');
    const product = immCard.getIn(['product', 'type']);

    const params = {
        query: {
            numeroContrato: contractNumber,
            pan,
            producto: product
        }
    };
    dispatch(limitsDataInProgress());

    return APIPost({
        dispatch,
        endpoint: 'limitsData',
        params
    }).then( response => {
        dispatch(limitsDataSuccess(response, type))
    }).catch( error => {
        dispatch(limitsDataFailure(error))
    });

};

const confirmModifyCommerceAndATMLimitsRequest = ( cardId, dataToken) => (dispatch, getState) => {
    const { modifyCommerceAndATMLimits: immModifyCommerceAndATMLimits, cards : immCards } = getState();
    const immCard = immCards.getIn(['byId', cardId]);

    if (!immModifyCommerceAndATMLimits.get('isFetching')) {

        const codigoLimite = immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'codigoLimite']);
        const importeNuevoLimite = immModifyCommerceAndATMLimits.getIn(['steps', FIRST_STEP, 'newSelectedLimit']);
        const divisaNuevoLimite = immCard.getIn(['limit', 'currency']);
        const numeroContrato = immCard.getIn(['contract', 'number']);
        const pan = immCard.get('number');
        const producto = immCard.getIn(['product', 'type']);

        const params = {
            query: {
                dataToken,
                codigoLimite,
                divisaNuevoLimite,
                importeNuevoLimite,
                numeroContrato,
                pan,
                producto
            }
        }

        dispatch(confirmModifyCommerceAndATMLimitsInProgress());

        return APIPost({dispatch, endpoint: 'modifyDebitLimits' , params})
            .then(
                (response) => {
                    dispatch(confirmModifyCommerceAndATMLimitsSuccess(response));
                    outdateGlobalPosition();
                }
            )
            .catch(response => dispatch(confirmModifyCommerceAndATMLimitsFailure(response.error)))
    }
};

const confirmModifyCommerceAndATMLimits = (cardId) => (dispatch, getState) => {
    validateAndExecute(dispatch, getState, (dispatch, getState, dataToken) => {
        dispatch(confirmModifyCommerceAndATMLimitsRequest(cardId, dataToken));
    });
}

module.exports = {
    limitsDataRequest,
    setLimitAmount,
    confirmModifyCommerceAndATMLimits,
    setVisibleStep,
    validateStep,
    showCancelModal,
    hideWarningModal,
    setLimitRanges,
    reset
};
